// @flow
import { makeGetRequest } from '../utils'

import type { ResponseAPI } from '../types/api'
import type { Movies } from '../types/movies'

export const getRelatedMovies = (domain: string, movieId: string, serviceId: string): Promise<ResponseAPI<Movies>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceId}/related/${movieId}/movies`)
